function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var UnitsTemplate = require('./units.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var UnitsOverlay = /*#__PURE__*/function () {
  function UnitsOverlay(app, mod) {
    _classCallCheck(this, UnitsOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, true, false);
  }
  return _createClass(UnitsOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var his_self = this.mod;
      this.overlay.show(UnitsTemplate());
      this.pushHudUnderOverlay();
      document.querySelector('.units-title').innerHTML = "Available Units";
      his_self.game.state.board['protestant'] = his_self.returnOnBoardUnits('protestant');
      his_self.game.state.board['papacy'] = his_self.returnOnBoardUnits('papacy');
      his_self.game.state.board['hapsburg'] = his_self.returnOnBoardUnits('hapsburg');
      his_self.game.state.board['england'] = his_self.returnOnBoardUnits('england');
      his_self.game.state.board['france'] = his_self.returnOnBoardUnits('france');
      his_self.game.state.board['ottoman'] = his_self.returnOnBoardUnits('ottoman');
      his_self.game.state.board['hungary'] = his_self.returnOnBoardUnits('hungary');
      his_self.game.state.board['scotland'] = his_self.returnOnBoardUnits('scotland');
      his_self.game.state.board['venice'] = his_self.returnOnBoardUnits('venice');
      his_self.game.state.board['genoa'] = his_self.returnOnBoardUnits('genoa');
      his_self.game.state.board['independent'] = his_self.returnOnBoardUnits('independent');
      for (var f in his_self.game.state.board) {
        var available = his_self.game.state.board[f].available;
        his_self.app.browser.addElementToSelector("\n\t  <div class=\"units-faction\">".concat(his_self.returnFactionName(f), "</div>\n\t  <div class=\"units-faction-available ").concat(f, "-units\"></div>\n        "), '.units-table');
        for (var i = 0; i < available['regular']['1']; i++) {
          var imgtile = '';
          if (f == 'hapsburg') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/hapsburg/HapsburgReg-1.svg\" />";
          }
          if (f == 'protestant') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/protestant/ProtestantReg-1.svg\" />";
          }
          if (f == 'papacy') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/papacy/PapacyReg-1.svg\" />";
          }
          if (f == 'ottoman') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/ottoman/OttomanReg-1.svg\" />";
          }
          if (f == 'france') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/france/FrenchReg-1.svg\" />";
          }
          if (f == 'england') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/england/EnglandReg-1.svg\" />";
          }
          if (f == 'scotland') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/scotland/ScottishReg-1.svg\" />";
          }
          if (f == 'venice') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/venice/VeniceReg-1.svg\" />";
          }
          if (f == 'genoa') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/genoa/GenoaReg-1.svg\" />";
          }
          if (f == 'hungary') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/hungary/HungaryReg-1.svg\" />";
          }
          if (f == 'independent') {
            imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/independent/IndependentReg-1.svg\" />";
          }
          var qs = ".units-faction-available.".concat(f, "-units");
          his_self.app.browser.addElementToSelector(imgtile, qs);
        }
        for (var _i = 0; _i < available['regular']['2']; _i++) {
          var _imgtile = '';
          if (f == 'hapsburg') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/hapsburg/HapsburgReg-2.svg\" />";
          }
          if (f == 'protestant') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/protestant/ProtestantReg-2.svg\" />";
          }
          if (f == 'papacy') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/papacy/PapacyReg-2.svg\" />";
          }
          if (f == 'ottoman') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/ottoman/OttomanReg-2.svg\" />";
          }
          if (f == 'france') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/france/FrenchReg-2.svg\" />";
          }
          if (f == 'england') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/england/EnglandReg-2.svg\" />";
          }
          if (f == 'scotland') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/scotland/ScottishReg-2.svg\" />";
          }
          if (f == 'venice') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/venice/VeniceReg-2.svg\" />";
          }
          if (f == 'genoa') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/genoa/GenoaReg-2.svg\" />";
          }
          if (f == 'hungary') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/hungary/HungaryReg-2.svg\" />";
          }
          if (f == 'independent') {
            _imgtile = "<img class=\"army_tile\" src=\"/his/img/tiles/independent/IndependentReg-2.svg\" />";
          }
          var _qs = ".units-faction-available.".concat(f, "-units");
          his_self.app.browser.addElementToSelector(_imgtile, _qs);
        }
        for (var _i2 = 0; _i2 < available['regular']['4']; _i2++) {
          var _imgtile2 = '';
          if (f == 'hapsburg') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/hapsburg/HapsburgReg-4.svg\" />";
          }
          if (f == 'protestant') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/protestant/ProtestantReg-4.svg\" />";
          }
          if (f == 'papacy') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/papacy/PapacyReg-4.svg\" />";
          }
          if (f == 'ottoman') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/ottoman/OttomanReg-4.svg\" />";
          }
          if (f == 'france') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/france/FrenchReg-4.svg\" />";
          }
          if (f == 'england') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/england/EnglandReg-4.svg\" />";
          }
          if (f == 'scotland') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/scotland/ScottishReg-4.svg\" />";
          }
          if (f == 'venice') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/venice/VeniceReg-4.svg\" />";
          }
          if (f == 'genoa') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/genoa/GenoaReg-4.svg\" />";
          }
          if (f == 'hungary') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/hungary/HungaryReg-4.svg\" />";
          }
          if (f == 'independent') {
            _imgtile2 = "<img class=\"army_tile\" src=\"/his/img/tiles/independent/IndependentReg-4.svg\" />";
          }
          var _qs2 = ".units-faction-available.".concat(f, "-units");
          his_self.app.browser.addElementToSelector(_imgtile2, _qs2);
        }
        for (var _i3 = 0; _i3 < available['regular']['6']; _i3++) {
          var _imgtile3 = '';
          if (f == 'hapsburg') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/hapsburg/HapsburgReg-6.svg\" />";
          }
          if (f == 'protestant') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/protestant/ProtestantReg-6.svg\" />";
          }
          if (f == 'papacy') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/papacy/PapacyReg-6.svg\" />";
          }
          if (f == 'ottoman') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/ottoman/OttomanReg-6.svg\" />";
          }
          if (f == 'france') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/france/FrenchReg-6.svg\" />";
          }
          if (f == 'england') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/england/EnglandReg-6.svg\" />";
          }
          if (f == 'scotland') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/scotland/ScottishReg-6.svg\" />";
          }
          if (f == 'venice') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/venice/VeniceReg-6.svg\" />";
          }
          if (f == 'genoa') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/genoa/GenoaReg-6.svg\" />";
          }
          if (f == 'hungary') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/hungary/HungaryReg-6.svg\" />";
          }
          if (f == 'independent') {
            _imgtile3 = "<img class=\"army_tile\" src=\"/his/img/tiles/independent/IndependentReg-6.svg\" />";
          }
          var _qs3 = ".units-faction-available.".concat(f, "-units");
          his_self.app.browser.addElementToSelector(_imgtile3, _qs3);
        }
        for (var _i4 = 0; _i4 < available['squadron']['1']; _i4++) {
          var _imgtile4 = '';
          if (f == 'hapsburg') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/hapsburg/Hapsburg_squadron.svg\" />";
          }
          if (f == 'papacy') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/papacy/Papacy_squadron.svg\" />";
          }
          if (f == 'ottoman') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/ottoman/Ottoman_squadron.svg\" />";
          }
          if (f == 'france') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/france/French_squadron.svg\" />";
          }
          if (f == 'england') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/england/English_squadron.svg\" />";
          }
          if (f == 'scotland') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/scotland/Scottish_squadron.svg\" />";
          }
          if (f == 'venice') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/venice/Venice_squadron.svg\" />";
          }
          if (f == 'genoa') {
            _imgtile4 = "<img class=\"army_tile\" src=\"/his/img/tiles/genoa/Genoa_squadron.svg\" />";
          }
          var _qs4 = ".units-faction-available.".concat(f, "-units");
          his_self.app.browser.addElementToSelector(_imgtile4, _qs4);
        }
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = UnitsOverlay;